import { Reducer } from "redux";

import { GeneralInfoResponse } from "../models/Api/AuthorizationDetailsTab";
import { GeneralInfoDispatchTypes } from "../models/DispatchTypes/AuthorizationDetailstab";
import { GeneralInfoActionDispatchTypes } from "../constants/Authorization";

const initialState: GeneralInfoResponse = {
    loading: false,
    response: {
        authorizationGeneralInfo: {
            dateTimeRequestReceived: "",
            authType: "",
            createdDate: "",
            authStatus: "",
            startOfCareDate: "",
            urgencyStatus: "",
            effectiveFrom: "",
            effectiveThrough: "",
        },
        icdCodesInfoDto: [],
        serviceAddress: {
            streetName1: "",
            streetName2: "",
            city: "",
            state: "",
            zipCode: 0,
        },
        serviceProvider: {
            agencyName: "",
            agencyNpi: 0,
            streetName1: "",
            streetName2: "",
            city: "",
            state: "",
            zipCode: 0,
            agencyPhone: "",
            agencyFax: "",
        },
    },
    error: null,
};

const GeneralInfoReducer: Reducer<
    GeneralInfoResponse,
    GeneralInfoDispatchTypes
> = (state = initialState, action) => {
    switch (action.type) {
        case GeneralInfoActionDispatchTypes.GENERAL_INFO_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case GeneralInfoActionDispatchTypes.GENERAL_INFO_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
        case GeneralInfoActionDispatchTypes.GENERAL_INFO_ERROR: {
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        }
        case GeneralInfoActionDispatchTypes.GENERAL_INFO_RESET: {
            return initialState;
        }
    }
    return state;
};
export default GeneralInfoReducer;
